
export function RoleBasedMainRoutes(role: string) {
    console.log("ROLECHEK",role)
    switch (role) {
        case "ADMIN": {
            return "/alert"
        }
        case "DEVELOPER": {
            return "/alert"
        }
        case "MIS": {
          return "/mis"
      }
      case "PDI":{
        return "/operation_console"
      }
        default: {
            return "/"
        }
    }
}